export default __webpack_public_path__ + "static/media/SortAscending.9de47305.svg";